export const swaggerColorStyles = `
        /* 1. REMOVER CABEÇALHO */
        .information-container,
        .scheme-container,
        .auth-wrapper,
        .authorize-wrapper,
        .swagger-ui .info {
            display: none !important;
        }
        
        /* 2. TROCAR CORES NO DARK MODE */
        /* Apenas transforma cores escuras em claras quando no dark mode */
        .dark .swagger-ui {
            /* Converte cores escuras para claras */
            filter: invert(1) hue-rotate(180deg);
        }
        
        /* Corrige imagens, background de botões, etc. que não devem inverter */
        .dark .swagger-ui img,
        .dark .swagger-ui .btn,
        .dark .swagger-ui .opblock-summary-method {
            filter: invert(1) hue-rotate(180deg);
        }
                 `